<template>
  <div class="page-access page-content">
    <PageHeader title="广告标识" />
    <div class="page-scroll-box">
      <span class="type-item">
        <div class="icon-img"><i class="icon-color" :style="`background-image: url(${colorImg})`" /></div>
        <div>{{colorSign}}</div>
        <div @click="downLoad(colorImg, colorSign)" class="download">下载</div>
      </span>
      <span class="type-item">
        <div class="icon-img"><i class="icon-gray" :style="`background-image: url(${grayImg})`" /></div>
        <div>{{graySign}}</div>
        <div @click="downLoad(grayImg, graySign)" class="download">下载</div>
      </span>
    </div>
  </div>
</template>

<script>
import PageHeader from '@/components/PageHeader'
import { isHL } from '@/common/utils';

export default {
  components: {
    PageHeader,
  },
  data(){
    return {
      colorSign: '彩色标识',
      graySign: '灰色标识'
    }
  },
  computed:{
    colorImg() {
      return `${origin}/logo_color${isHL() ? '_hl' : ''}.png`
    },
    grayImg() {
      return `${origin}/logo_gray${isHL() ? '_hl' : ''}.png`
    }

  },
  methods: {
    downLoad(img, name){
      console.log(img)
      var link = document.createElement("a");
      link.download = name
      link.href = img
      link.click();
      link.remove();
    }
  }
}
</script>

<style lang="scss" scoped>
@import "~@/assets/css/page.scss";

.page-access {
  .page-scroll-box {
    display: flex;
  }
}

.type-item {
  display: flex;
  flex-direction:column;
  align-items: center;
  justify-content:space-around;
  width: 170px;
  height: 170px;
  padding: 10px;
  .icon-img {
    width: 100px;
    height: 100px;
    .icon-color {
      display: inline-block;
      width: 100%;
      height: 100px;
      background-size: 100% 100%;
      background-position: center;
      background-repeat: no-repeat;
    }
    .icon-gray {
      display: inline-block;
      width: 100px;
      height: 75px;
      background-size: 100% 100%;
      background-position: center;
      background-repeat: no-repeat;
      margin-top: 12px; 
    }
  }
  .download {
    color: #4F90FF;
    cursor: pointer;
  }
}

</style>
